import React from 'react';
import validator from 'validator';
import { COUNTRY_DOCUMENT_TYPE_DNI } from 'constants/multiLanguage';
import { InputText } from 'components/inputText/inputText';
import { LASTNAME_DISCLAIMER } from 'constants/featureFlagging';
import { formatText } from 'core/i18n';
import { getLastNameValidationRegExp } from 'commonsUtilities/validations';
import { LastNameDisclaimerImportantMessage } from './LastNameDisclaimerImportantMessage/LastNameDisclaimerImportantMessage';

export const LastName = ({
    userProfile,
    userProfileForm,
    formActions,
    validateGroups,
    showDisclaimer,
    setShowDisclaimer,
    onFocus,
}) => {
    const handleRequiredField = value => value && value.length;

    const isLastNameValidForCountry = (value, country) =>
        validator.matches(value, getLastNameValidationRegExp[country]);

    const isValidLastNameLengthForSpanishPeople = value => value.length <= 26;

    const isValidLastNameLengthForForeignPeople = value => value.length <= 52;

    const isLastNameLongerThanOneCharachter = value => value.length >= 2;

    const isDocumentTypeDNI = userProfile.documentType === COUNTRY_DOCUMENT_TYPE_DNI;

    const isValidField = value =>
        isLastNameValidForCountry(value, __ORIGIN_COUNTRY__) &&
        isLastNameLongerThanOneCharachter(value) &&
        (isDocumentTypeDNI
            ? isValidLastNameLengthForSpanishPeople(value)
            : isValidLastNameLengthForForeignPeople(value));

    const handleValidField = value => {
        isValidField(value) && setShowDisclaimer(false);

        return isValidField(value);
    };

    const handleValidations = {
        required: handleRequiredField,
        valid: handleValidField,
    };

    const handleMessagesError = {
        required: formatText('validation-fieldRequired'),
        valid: formatText('validation-syntaxError'),
    };

    const handleOnFocus = () => {
        setShowDisclaimer(true);
        onFocus();
    };

    const handleIsValidated = () => {
        validateGroups?.('lastName', true);
    };

    const handleIsNotValidated = () => {
        validateGroups?.('lastName', false);
    };

    return (
        <div className="row form__input md-form-group">
            <div className="col-lg-12">
                <label htmlFor="lastName">{formatText('field-lastName')}</label>
            </div>
            <div className="col-sm-6">
                <InputText
                    profileModel="userProfile.lastName"
                    placeholder={formatText('field-placeholderLastName')}
                    type="text"
                    inputMode="text"
                    name="lastName"
                    autoCompleteFieldCustom={'additional-name'}
                    defaultValue={userProfile.lastName}
                    validations={handleValidations}
                    isNotValidated={handleIsNotValidated}
                    isValidated={handleIsValidated}
                    onFocus={handleOnFocus}
                    messagesError={handleMessagesError}
                    userProfileForm={userProfileForm}
                    userProfile={userProfile}
                    formActions={formActions}
                />
            </div>
            {showDisclaimer && <LastNameDisclaimerImportantMessage notAllowedProductKey={LASTNAME_DISCLAIMER} />}
        </div>
    );
};
